import React from 'react';
import './Modal.scss';
import CloseIcon from '@mui/icons-material/Close';
import {constructClassNames} from '../../helpers/helpers';

const Modal = (
  {
    title,
    children,
    closeModal,
    width,
    height,
    imagePreview
  }
) => {
  const contentClasses = [
    {name: 'noTitle', condition: !title},
  ];

  return (
    <div className='modalBackgroundBlur'>
      <div className='modalBox' style={{width: width ? width : 'fit-content', height: height ? height : 'fit-content'}}>
        <div className='closeButton' onClick={closeModal}>
          <CloseIcon />
        </div>
        {!!title && <div className='modalTitle'>{title}</div>}
        {!imagePreview && (
          <div className={constructClassNames('modalContent', contentClasses)}>
            {children}
          </div>
        )}
        {!!imagePreview && (
          <div className='modalContentImage'>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
